import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速浏览引擎',
    description: '自研"闪电"渲染引擎，网页加载速度比主流浏览器快300%，首屏渲染平均仅需1.2秒。',
    slug: '91-browser-speed-engine',
    bgColor: 'bg-accent-100',
    iconColor: 'text-accent-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: '五重隐私保护',
    description: '无痕浏览、智能广告拦截、HTTPS强制升级、密码保险箱、隐私报告面板，全方位守护。',
    slug: '91-browser-privacy-mode',
    bgColor: 'bg-primary-100',
    iconColor: 'text-primary-600',
  },
  {
    icon: 'ri-device-line',
    title: '多端实时同步',
    description: 'Windows、macOS、Android、iOS全平台覆盖，书签密码自动同步，设备切换无缝衔接。',
    slug: '91-browser-sync-guide',
    bgColor: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
  },
  {
    icon: 'ri-palette-line',
    title: '个性主题定制',
    description: '超过5000款精美主题免费使用，支持自定义设计器，打造专属浏览器界面。',
    slug: '91-browser-theme-custom',
    bgColor: 'bg-accent-100',
    iconColor: 'text-accent-600',
  },
  {
    icon: 'ri-advertisement-line',
    title: '智能广告拦截',
    description: '动态行为分析精准识别广告，拦截率超过99.7%，同时保留正常网页功能。',
    slug: '91-browser-adblock',
    bgColor: 'bg-primary-100',
    iconColor: 'text-primary-600',
  },
  {
    icon: 'ri-cloud-line',
    title: '网页版即开即用',
    description: '无需安装客户端，打开网页即可享受极速浏览，适合临时设备与轻量使用场景。',
    slug: '91-browser-web-login',
    bgColor: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
  },
];

export default function FeatureSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4">
            核心功能
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择<strong className="text-primary-500">91浏览器</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-2xl mx-auto">
            六大核心功能，从速度、安全、便利到个性化，全面升级您的上网体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <Link
              key={feature.slug}
              to={`/article/${feature.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 p-6 hover:border-primary-300/60 transition-all duration-300"
            >
              <div className={`w-11 h-11 rounded-lg ${feature.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} ${feature.iconColor} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}